import DeliveryMethods from './DeliveryMethods';

export default DeliveryMethods;


// WEBPACK FOOTER //
// ./src/components/DeliveryMethods/index.tsx